import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, ViewEncapsulation } from "@angular/core";

import type { ChatRuntimeController } from './chat-runtime.controller';

@Component({
  selector: "app-chat-conversation",
  templateUrl: "./chat-conversation.component.html",
  styleUrls: [
    "./chat.component.toolbar-and-shell.scss",
    "./chat.component.message-interactions.scss",
    "./chat.component.answer-content-and-feedback.scss",
    "./chat.component.composer-and-details.scss",
    "./chat.component.source-list.scss",
    "./chat.component.themes-and-source-detail.scss",
    "./chat.component.grounding.scss",
    "./chat.component.context-menu-and-role-selector.scss",
    "./chat.component.role-feedback.scss",
    "./chat-modal.component.dialog-layout.scss",
    "./chat-modal.component.session-editor.scss"
  ],
  encapsulation: ViewEncapsulation.None,
  host: { style: "display: contents" },
  standalone: false
})
export class ChatConversationComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) view!: ChatRuntimeController;
  @ViewChild("chatContainer", { static: true }) chatContainer?: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.view.state.chatContainer = this.chatContainer;
  }

  ngOnDestroy(): void {
    if (this.view.state.chatContainer === this.chatContainer) {
      this.view.state.chatContainer = undefined;
    }
  }
}
